import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/core/abstracts/base.component';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { NgForm } from '@angular/forms';
import * as PerasisEditor from 'libs/ckeditor5-build-perasis';
import { CKEditorConfig } from 'src/app/configs/ckeditor-settings.config';
import { ChangeEvent, CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { StudentModel } from 'src/app/core/models/student.model';
import { TrainingModel } from 'src/app/core/models/training.model';
import { ReportCommentModel } from 'src/app/core/models/survey/report-comment.model';
import { ClassModel } from 'src/app/core/models/class.model';
import { CompanyModel } from 'src/app/core/models/finance/company.model';

@Component({
  selector: 'app-training-class-print',
  templateUrl: './training-class-print.component.html',
  styleUrls: ['./training-class-print.component.scss']
})
export class TrainingClassPrintComponent extends BaseComponent implements OnInit {

  reportDescription: { id:number; title: string; description: string; }[] = [];
  isVisibleDescriptionModal:boolean = false;
  isVisibleDescriptionUpdateModal:boolean = false;
  index:number = 0;
  editID:number = 0;
  isLoading:boolean = false;
  isCreating:boolean = false;
  isButton:boolean = false;
  isNewPage:boolean = false;
  Title:string = null;
  Description:string = null;
  classID:string = null;
  trainingID:string = null;
  reportImageBase64:[] = [];
  tableData: any = [];
  trainingModel:TrainingModel = new TrainingModel();
  model:ReportCommentModel = new ReportCommentModel();
  modelClass:ClassModel = new ClassModel();
  modelCompany:CompanyModel = new CompanyModel();

  @ViewChild('f', {static: false})
  f: NgForm;

  @ViewChild('g', {static: false})
  g: NgForm;

  //#region editor start
   public Editor = PerasisEditor;
   @ViewChild('editor', {static: false}) editorComponent: CKEditorComponent;
 
   public EditorConfig = CKEditorConfig;
 
   public onEditorReady(editor) {
     editor.ui.getEditableElement().parentElement.insertBefore(
       editor.ui.view.toolbar.element,
       editor.ui.getEditableElement()
     );
   }
 
   public onEditorChange({ editor }: ChangeEvent) {
     const data = editor.getData();
   }
 
   //#endregion editor end

  ngOnInit() {
    this.route.params.subscribe(params => {
        
      if(params.classid && params.trainingid){
        this.classID = params.classid;
        this.trainingID = params.trainingid;
        this.reportImageBase64 = JSON.parse(localStorage.getItem('reportImage'));
        
        this.getModel();

      }
      else if(!params.classid && params.trainingid){
        this.classID = params.classid;
        this.trainingID = params.trainingid;
        this.reportImageBase64 = JSON.parse(localStorage.getItem('reportImage'));
        this.getAllReportModel();
      }
     
     
    })

    
  }



  getModel() {
    this.isLoading = true;
    this.mediaService.getReportClassInfo(this.classID, this.trainingID)
      .subscribe(result => {
        if (result.Class != null) {

          this.modelClass = result.Class;
          this.tableData = result.ClassStudent;

        }

        if(result.Company){
          this.modelCompany = result.Company;
        }

        this.trainingModel = result.Training;
     
        if(result.ReportComment){
          this.reportDescription = JSON.parse(result.ReportComment.Template);
        }
        else{
          this.reportDescription = [];
        }
      },
        error => {
          this.isLoading = false;

        });
  }

  getAllReportModel() {
    this.isLoading = true;
    this.mediaService.getReportAllInfo(this.trainingID)
      .subscribe(result => {
        if (result.ClassStudent != null) {

          this.tableData = result.ClassStudent;

        }

        if(result.Company){
          this.modelCompany = result.Company;
        }

        this.trainingModel = result.Training;
     
        if(result.ReportComment){
          this.reportDescription = JSON.parse(result.ReportComment.Template);
        }
        else{
          this.reportDescription = [];
        }
      },
        error => {
          this.isLoading = false;

        });
  }

  

  createModel(){
    let max = 0;
    if(this.reportDescription.length > 0){
      this.reportDescription.forEach(character => {
        if (character.id > max) {
          max = character.id;
        }
      });
      max = max + 1;
    }
    
    this.reportDescription.push({id:max,title:this.Title, description:this.Description});
    // this.index++;
    
    this.cancel();
    setTimeout(() => {
      this.createTemplate();
    }, 0);
    
  }
  showUpdateModal(value){
    this.editID = value;
    this.reportDescription.forEach(element => {

      if(element.id == value){
        this.Title = element.title;
        this.Description = element.description;
      }

    });

    this.isVisibleDescriptionUpdateModal = true;
    
  }
  updateModal(){
    
    this.reportDescription.forEach(element => {

      if(element.id == this.editID){
        element.title = this.Title;
        element.description = this.Description;
      }

    });
    this.cancel();
    setTimeout(() => {
      this.createTemplate();
    }, 0);
  }

  deleteModal(){

    for( var i = 0; i < this.reportDescription.length; i++){ 
      
      if (this.reportDescription[i].id == this.editID) { 
        
        this.reportDescription.splice(i,1);
      }
    
    }
    

    this.cancel();
    setTimeout(() => {
      this.createTemplate();
    }, 0);
  }

  cancel(){
    this.isVisibleDescriptionModal = false;
    this.isVisibleDescriptionUpdateModal = false;
    this.Title = null;
    this.Description = null;
    this.editID = null;
    this.f.resetForm();
    this.g.resetForm();
  }

  htmltoPDF()
  {
      // parentdiv is the html element which has to be converted to PDF
      html2canvas(document.querySelector("#parentdiv")).then(canvas => {

        var pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);

        var imgData  = canvas.toDataURL("image/jpeg", 1.0);
        pdf.addImage(imgData,0,0,canvas.width, canvas.height);
        pdf.save('rapor.pdf');

    });


  }
  print(){
    window.print();
  }

  createTemplate(){
    this.isCreating = true;
    this.model.Template = JSON.stringify(this.reportDescription);
    this.model.TrainingID = this.trainingModel.TrainingID;
    this.model.ClassID = this.classID;
    this.reportCommentService.create(this.model)
      .subscribe(
        (result) => {
          if (result.Success) { //Student created
            this.isCreating = false;
            this.commonFunctionsService.showNotification("success","İşlem Başarılı");
          }
          else {
            this.isCreating = false;
            this.onResult.emit(result);
            this.commonFunctionsService.showNotification("success",result.Message);
          }
        },
        (error) => {
          this.isCreating = false;
          this.commonFunctionsService.showNotification("success","Hata meydana geldi",true);
        }
      );
  }

  isEveryPageOneReport:boolean = false;
  
}


